// 予約枠の種別.
// design 参照: ReservableSlotsV2.logic.tsx の RenderableSlotData.slotType
export type SlotType =
	| "CURRENT_STAFF_AVAILABLE"
	| "OTHER_STAFF_AVAILABLE"
	| "NOT_AVAILABLE"

// 表示中 chunks の slot が予約可能かを判定する.
// CURRENT_STAFF_AVAILABLE は常に可能、OTHER_STAFF_AVAILABLE は
// allowsDifferentStaffReservation が許可されている時のみ可能 (呼び出し側で「サロン設定 && visit_count < 1」を AND して渡す想定).
export const isSlotReservable = (
	slot: { slotType: SlotType },
	allowsDifferentStaffReservation: boolean
): boolean => {
	if (slot.slotType === "CURRENT_STAFF_AVAILABLE") {
		return true
	}
	if (slot.slotType === "OTHER_STAFF_AVAILABLE") {
		return allowsDifferentStaffReservation
	}
	return false
}

// 週ナビ内に表示する incentive 進捗バーの左ラベル.
// 右ラベルとゲージ幅は表示中 chunks の予約可能枠数から子側で計算する.
export type IncentiveProgressInfo = {
	leftLabel: string
}
